import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage === 'en' ? 'en' : 'pt-BR';

  const changeLanguage = (language) => {
    if (language !== currentLanguage) i18n.changeLanguage(language);
  };

  return (
    <div
      className={`language-switcher ${className}`.trim()}
      role="group"
      aria-label={t('common.language')}
    >
      <button
        type="button"
        className={currentLanguage === 'pt-BR' ? 'is-active' : ''}
        aria-pressed={currentLanguage === 'pt-BR'}
        title={t('common.portuguese')}
        onClick={() => changeLanguage('pt-BR')}
      >
        PT
      </button>
      <button
        type="button"
        className={currentLanguage === 'en' ? 'is-active' : ''}
        aria-pressed={currentLanguage === 'en'}
        title={t('common.english')}
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
    </div>
  );
}
